let Translations = {
    fr: {
        clear: 'clear'
    },
    en: {
        clear: 'clear'
    },
    zh: {
        clear: 'clear'
    }
};
export {Translations}